import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { AlertTriangle, ShieldAlert, Sparkles } from "lucide-react";

export default function WarningBanner() {
  const { user } = useAuth();
  if (!user || user === false) return null;
  const s = user.warnings_summary;
  if (!s || s.active_count === 0) return null;
  const isHard = s.hard_count > 0;
  const Icon = isHard ? ShieldAlert : AlertTriangle;
  return (
    <div
      className={`border-l-4 rounded-md p-3 mb-4 flex items-center justify-between gap-3 ${isHard ? "border-red-500 bg-red-50 text-red-900" : "border-orange-500 bg-orange-50 text-orange-900"}`}
      data-testid="warnings-banner"
    >
      <div className="flex items-center gap-3">
        <Icon className="w-5 h-5 shrink-0" />
        <div className="text-sm">
          <span className="font-semibold">
            {s.hard_count > 0 && <>You have {s.hard_count} active hard {s.hard_count === 1 ? "warning" : "warnings"}.</>}
            {s.hard_count === 0 && s.soft_count > 0 && <>You have {s.soft_count} active soft {s.soft_count === 1 ? "warning" : "warnings"}.</>}
          </span>
          {isHard && (
            <span className="ml-1">
              {s.hard_strikes_remaining > 0
                ? `${s.hard_strikes_remaining} more will deactivate your account.`
                : "Your account is currently deactivated."}
            </span>
          )}
          <span className="ml-1 inline-flex items-center gap-1 text-xs">
            <Sparkles className="w-3 h-3" />
            {s.appreciations_needed_to_clear > 0
              ? `${s.appreciations_needed_to_clear} more appreciations clear all warnings.`
              : "Next appreciation will clear all warnings."}
          </span>
        </div>
      </div>
      <Link
        to="/my-warnings"
        className="text-xs font-semibold uppercase tracking-widest underline whitespace-nowrap"
        data-testid="warnings-banner-link"
      >
        View
      </Link>
    </div>
  );
}
